const PROD = import.meta.PROD;
const USERS_RESOURCE = 'http://users.omniportal.app'

const UNITS = [
  { value: 'hour', label: 'Hour' },
  { value: 'terabyte', label: 'TB' },
  { value: 'terabit', label: 'Tb' },
  { value: 'gigabyte', label: 'GB' },
  { value: 'gigabit', label: 'Gb' },
  { value: 'megabyte', label: 'MB' },
  { value: 'megabit', label: 'Mb' },
  { value: 'unit', label: 'Unit(s)' },
  { value: 'hours', label: 'Hours' },
  { value: 'node_minute', label: 'Node Minute' },
  { value: 'minute', label: 'Minute' },
  { value: 'gigabyte_hour', label: 'GB Hour' },
  { value: 'gigabyte_minute', label: 'GB Minute' },
  { value: 'ip_minute', label: 'IP Minute' },
  { value: 'gigabyte_month', label: 'GB Month' },
  { value: 'request', label: 'Request' },
  { value: 'version_minute', label: 'Version Minute' }
] as const;

const GROUP_OPTIONS = [
  { value: 'db', label: 'DB' },
  { value: 'vcpu', label: 'VCPU' },
  { value: 'db-cluster', label: 'DB-Cluster' },
  { value: 'db-storage', label: 'DB-storage' },
  { value: 'snapshot', label: 'Snapshot' },
  { value: 'node', label: 'NODE' },
  { value: 'cpu', label: 'CPU' },
  { value: 'gp-vcpu', label: 'GP-VCPU' },
  { value: 'network', label: 'Network' },
  { value: 'object-storage', label: 'Object Storage' },
  { value: 'storage', label: 'Storage' },
  { value: 'containers', label: 'Containers' },
  { value: 'points', label: 'Points' }
] as const;

const COUNTRY_OPTIONS = [
  { value: 'NL', label: 'NL' },
  { value: 'FR', label: 'FR' },
  { value: 'POL', label: 'POL' },
  { value: 'US', label: 'US' }
] as const;

const CITY_OPTIONS = [
  { value: 'AMS', label: 'AMS' },
  { value: 'PAR', label: 'PAR' },
  { value: 'WAW', label: 'WAW' },
  { value: 'NY', label: 'NY' }
] as const;

const PRODUCT_CATEGORIES = [
  { value: 'compute-instances', label: 'Compute Instances' },
  { value: 'managed-databases', label: 'Managed Database' },
  { value: 'load-balancer', label: 'Load Balancer' },
  { value: 'bandwidth', label: 'Bandwidth' },
  { value: 'block-storage', label: 'Block Storage' },
  { value: 'kubernetes', label: 'Kubernetes' },
  { value: 'snapshots', label: 'Snapshots' },
  { value: 'backups', label: 'Backups' },
  { value: 'object-storage', label: 'Object Storage' },
  { value: 'flexible-ip', label: 'Flexible IP' },
  { value: 'security-identity', label: 'Security' },
  { value: 'network', label: 'Network' },
  { value: 'observability', label: 'Observability' },
  { value: 'observability-metrics', label: 'Observability - Metrics' },
  { value: 'observability-logs', label: 'Observability - Logs' },
  { value: 'observability-traces', label: 'Observability - Traces' },
  { value: 'taxes', label: 'Taxes' },
  { value: 'other', label: 'Other' }
] as const


export {
  PROD,
  USERS_RESOURCE,
  UNITS,
  PRODUCT_CATEGORIES,
  GROUP_OPTIONS,
  COUNTRY_OPTIONS,
  CITY_OPTIONS
};
